import constants from '../constant';

const globals = {
    clientDomain: constants.clientDomain,
    roomDomain: constants.roomDomain,
    transcriptionBaseUrl: constants.transcriptionBaseUrl,
    widBaseUrl: constants.widBaseUrl,
};
export default globals;
